import { createRouter, createWebHistory } from "vue-router";
import authRoutes from "./authRoutes";
import dashboardRoutes from "./dashboardRoutes";
// App routes
import subscriberRoutes from "./subscriberRoutes";
import purchaseRoutes from "./purchaseRoutes";
import pushManagementRoutes from "./pushManagementRoutes";
import feedBackRoutes from "./feedBackRoutes";

import settingRoutes from "./settingRoutes";
import supportToken from "./supportToken";

const routes = [
  {
    name: "guest",
    path: "/login",
    component: () => import("../components/layouts/Guest.vue"),
    meta: {
      middleware: "guest",
    },
    children: authRoutes,
  },
  {
    name: "base",
    path: "/",
    component: () => import("../components/layouts/Default.vue"),
    meta: {
      middleware: "auth",
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        redirect: { name: "home" },
      },
      ...dashboardRoutes,
      ...subscriberRoutes,
      ...purchaseRoutes,
      ...pushManagementRoutes,
      ...feedBackRoutes,
      ...settingRoutes,
      ...supportToken,
      {
        path: ":pathMatch(.*)*",
        name: "admin-notfound",
        component: () => import("../components/common/404NotFound.vue"),
        meta: {
          title: "Page not found",
        },
      },
    ],
  },
];

const router = createRouter({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = localStorage.getItem("jwt_token") != null;
  const isGuestOnly = to.name === "login" || to.name === "reset-password";

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      next({ name: "login" });
      return;
    }
    next();
    return;
  }

  if (isGuestOnly && isLoggedIn) {
    next({ name: "home" });
    return;
  }

  next();
});

export default router;
